import { useEffect, useState } from "react";
import { Hero } from "@/sections/Hero";
import { Historias } from "@/sections/Historias";
import { Produto } from "@/sections/Produto";
import { SimpatiaGratuita } from "@/sections/SimpatiaGratuita";
import { Faq } from "@/sections/Faq";
import { Encerramento } from "@/sections/Encerramento";
import { Marquee } from "@/components/mystic/Marquee";
import { CookieConsent } from "@/components/CookieConsent";
import { useSettings, priceValue } from "@/lib/settings";
import { initTracking, trackEvent } from "@/lib/tracking";

export default function Landing() {
  const { settings, loading } = useSettings();
  const [consent, setConsent] = useState(
    () => localStorage.getItem("medv_consent") === "yes"
  );

  useEffect(() => {
    if (!loading && consent) {
      initTracking(settings);
      trackEvent("ViewContent", {
        value: priceValue(settings),
        currency: "BRL",
        content_name: "Meu Ex de Volta — 50 Simpatias",
        content_type: "product",
      });
    }
  }, [loading, consent, settings]);

  const acceptConsent = () => {
    localStorage.setItem("medv_consent", "yes");
    setConsent(true);
  };

  return (
    <main data-testid="landing-page" className="bg-obsidian">
      <Hero />
      <Historias />
      <Marquee />
      <Produto />
      <SimpatiaGratuita />
      <Faq />
      <Encerramento />
      <CookieConsent visible={!consent} onAccept={acceptConsent} />
    </main>
  );
}
